/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type SonicResultMessage = {
    readonly id?: number;
    status?: SonicResultMessage.status;
    /**
     * Optional reason for error status
     */
    error_reason?: string | null;
    readonly created_at?: string;
}

export namespace SonicResultMessage {

    export enum status {
        PENDING = 'pending',
        SUCCESS = 'success',
        ERROR = 'error',
        HOLD = 'hold',
        DROPPED = 'dropped',
    }


}
